import { gql } from "@apollo/client";

const PLATFORM_TOURNAMENTS = gql`
  query leagueTournaments($filter: ListLeagueInput) {
    leagueTournaments(filter: $filter)
  }
`;

export default PLATFORM_TOURNAMENTS;
